import React from "react";
import CellLinked from "./CellLinked";
import Checkbox from "../../Checkbox";

function CellWithCheckboxLinked({
    value = null,
    isChecked = false,
    id = null,
    link = null,
    maxLength = 20,
    onCheck = () => {},
}) {
    return (
        <div className="table-cell_checkboxed" id={id}>
            <Checkbox label="" checked={isChecked} onChange={onCheck} />
            <CellLinked value={value} link={link} maxLength={maxLength} />
        </div>
    );
}


export default CellWithCheckboxLinked;
